import { Flex } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import FieldCheckbox from '@/components/shared/form/FieldCheckbox';
import { TreeStore } from '@/stores/local/shared/TreeStore';
import { useSidebarDocumentsStore } from '@/stores/local/sidebar/SidebarDocumentsStore';

type Props = {
  store: TreeStore;
};

const Actions: React.FC<Props> = ({ store }) => {
  const { selectionStore } = useSidebarDocumentsStore();
  const state = selectionStore.getNodeState(store);

  const handleClick = React.useCallback(() => {
    if (store.isVirtualFolder) {
      return;
    }

    selectionStore.selectOnly(store);
  }, [selectionStore, store]);

  return (
    <Flex align="center" gap="xxs">
      <FieldCheckbox
        checked={state.checked}
        indeterminate={state.indeterminate}
        onToggle={handleClick}
        disabled={store.isVirtualFolder}
      />
    </Flex>
  );
};

export default observer(Actions);
